import { UserRound } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

/** Authenticated main-header action; preserves the originating screen for profile back navigation. */
export function ProfileButton() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) return null;
  return (
    <Link
      to="/profile"
      state={{
        from: {
          pathname: location.pathname,
          search: location.search,
          hash: location.hash,
        },
      }}
      aria-label="مشاهده پروفایل"
      title="پروفایل"
      className="hover:border-brand/40 flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200/90 bg-white text-slate-700 shadow-xs transition-colors hover:bg-slate-50"
    >
      <UserRound className="h-4 w-4" aria-hidden="true" />
    </Link>
  );
}
